/** URL encoded into a receipt's QR — token-gated, no login required to view. */
export function publicReceiptUrl(token: string): string {
  return `${window.location.origin}/r/${token}`;
}
